// Source of truth mirrors locale-codes.json (used by next.config.js).
const localeData = {
  defaultLocale: 'default',
  languages: {
    arSA: {
      id: 'ar-SA',
      title: 'Arabic',
      preferenceCode: 'ar',
      label: 'العربية',
    },
    deDE: {
      id: 'de-DE',
      title: 'German',
      preferenceCode: 'de',
      label: 'Deutsch',
    },
    elGR: {
      id: 'el-GR',
      title: 'Greek',
      preferenceCode: 'el',
      label: 'Ελληνικά',
    },
    enUS: {
      id: 'en-US',
      title: 'English',
      preferenceCode: 'en-US',
      label: 'English',
    },
    enAE: {
      id: 'en-AE',
      title: 'English (U.A.E.)',
    },
    enEG: {
      id: 'en-EG',
      title: 'English (Egypt)',
    },
    enIN: {
      id: 'en-IN',
      title: 'English (India)',
    },
    enEU: {
      id: 'en-EU',
      title: 'English (Europe)',
    },
    enSA: {
      id: 'en-SA',
      title: 'English (Saudi Arabia)',
    },
    esES: {
      id: 'es-ES',
      title: 'Spanish',
      preferenceCode: 'es',
      label: 'Español',
    },
    frCA: {
      id: 'fr-CA',
      title: 'French (Canada)',
      preferenceCode: 'fr-CA',
      label: 'Français (Canada)',
    },
    frFR: {
      id: 'fr-FR',
      title: 'French (France)',
      preferenceCode: 'fr',
      label: 'Français',
    },
    idID: {
      id: 'id-ID',
      title: 'Indonesian',
      preferenceCode: 'id-ID',
      label: 'Bahasa Indonesia',
    },
    itIT: {
      id: 'it-IT',
      title: 'Italian',
      preferenceCode: 'it',
      label: 'Italiano',
    },
    ja: {
      id: 'ja',
      title: 'Japanese',
      preferenceCode: 'ja',
      label: '日本語',
    },
    koKR: {
      id: 'ko-KR',
      title: 'Korean',
      preferenceCode: 'ko',
      label: '한국어',
    },
    kuIR: {
      id: 'ku-IR',
      title: 'Kurdish (Sorani)',
      preferenceCode: 'ku',
      label: 'کوردی',
    },
    ptBR: {
      id: 'pt-BR',
      title: 'Portuguese (Brazil)',
      preferenceCode: 'pt-BR',
      label: 'Português (Brasil)',
    },
    ptPT: {
      id: 'pt-PT',
      title: 'Portuguese (Portugal)',
      preferenceCode: 'pt-PT',
      label: 'Português (Portugal)',
    },
    ruRU: {
      id: 'ru-RU',
      title: 'Russian',
      preferenceCode: 'ru',
      label: 'Русский',
    },
    trTR: {
      id: 'tr-TR',
      title: 'Turkish',
      preferenceCode: 'tr',
      label: 'Türkçe',
    },
    zhCN: {
      id: 'zh-CN',
      title: 'Chinese',
    },
  },
} as const;

export default localeData;
